import Marionette from 'backbone.marionette';
import billDetailAuthorItemviewTmpl from '../templates/bill_detail_author_itemview.tpl';
export default Marionette.ItemView.extend({
  template: billDetailAuthorItemviewTmpl,
  tagName: "li",
  className: function () {
    return "media " + this.model.get("party");
  }
});